import {TIconType} from 'components/dynamic-icon/dynamic-icon';
import {EEntityType} from 'shared/constants/entities';

import {IS_MENU_ITEM_HIDDEN_KEY} from './menu-slice-constants';

export interface IMenuSliceState {
    selectedMenusIds: string[];

    isMenuOpen?: boolean;
    searchLine: string | undefined;

    structure: TMenuStructure | null;
    structureIdMap: Record<string, IMenuStructureItem> | null;

    meta: {
        openId: string | undefined;
    };
}

export enum EMenuItemType {
    FUNCTION_ITEM = 'FUNCTION_ITEM',
    MENU_ITEM = 'MENU_ITEM'
}

export interface IMenuResponseItem {
    itemTitle: string;
    itemKey: string;
    parentId: string | null;
    id: string;
    itemType: EMenuItemType;
    icon: TIconType | null;
    entityName: string;
    entityType?: EEntityType;
    url: string;
    docId: string;
    templateCode: string;
    parameters: any;
}

export type TMenuResponse = IMenuResponseItem[];

export interface IMenuStructureItem extends IMenuResponseItem {
    [IS_MENU_ITEM_HIDDEN_KEY]?: boolean;
    children?: IMenuStructureItem[];
}

export interface IGenerateRouteArgs extends IMenuStructureItem {
    parentEntityName?: string;
    childEntityName?: string;
    skipRawChildrenCheck?: boolean;
}

export type TMenuStructure = IMenuStructureItem[];
